import React from 'react'
import MobileEmptyStateCard from '../../components/MobileEmptyStateCard'
import { formatMoney, formatDiscountPercent } from '../../helpers/utils'

const OrderDetailsLineCard = ({ model, customFieldKeys }) => {
  const staticRows = [
    ['Código', model.product_db_ref],
    ['Unidad de venta', model.price_unit],
    ['Cantidad', Number(model.quantity).toFixed(2)],
    ['Precio', formatMoney(Number(model.unit_price))],
    ['% descuento', formatDiscountPercent(model.discount)],
    ['Sub-total', formatMoney(model.extended_price)]
  ]

  return (
    <div className="order-detail-line-card">
      <div className="order-detail-line-product-name">{model.product_name}</div>
      {staticRows.map(([label, value]) => (
        <div key={label} className="order-detail-line-row">
          <span className="order-detail-line-label">{label}</span>
          <span className="order-detail-line-value">{value}</span>
        </div>
      ))}
      {customFieldKeys.map((field) => {
        const fieldData = model.parsedFields.find((f) => f.label === field)
        return (
          <div key={field} className="order-detail-line-row">
            <span className="order-detail-line-label">{field}</span>
            <span className="order-detail-line-value column-custom">{fieldData?.value ?? '-'}</span>
          </div>
        )
      })}
    </div>
  )
}

const OrderDetailsTabMobileLines = ({ parsedDetails, customFieldKeys }) => {
  if (!parsedDetails?.length) {
    return (
      <MobileEmptyStateCard
        title="No hay productos"
        description="Cuando este pedido tenga productos asociados, aparecerán aquí."
      />
    )
  }

  return (
    <div className="order-detail-line-items-mobile">
      {parsedDetails.map((model, index) => (
        <OrderDetailsLineCard key={index} model={model} customFieldKeys={customFieldKeys} />
      ))}
    </div>
  )
}

export default OrderDetailsTabMobileLines
